import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/xena-api/controllers/base';
import { IOrderTask } from 'src/app/xena-api/dtos';
import { IQueryStringFilter } from 'src/app/xena-api/filters';
import { Page } from 'src/app/xena-api/response-types';
import { Observable } from 'rxjs';
import { ContextService, XenaClient } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class OrderTaskService extends BaseService<IOrderTask, IOrderTaskFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'OrderTask');
  }

  getByNumbers(orderTaskNumbers: string[]): Observable<Page<IOrderTask>> {
    const buildUrl = this.buildUrl();
    const resourcePath: string = `${buildUrl}/ByNumbers?orderTaskNumbers=${orderTaskNumbers}`;

    return this.xenaClient.list(resourcePath);
  }

}

export interface IOrderTaskFilter extends IQueryStringFilter {
  contextType?: ContextType
}

export type ContextType = 'ContextType_Customer' | 'ContextType_Supplier';
